import { CareerRoleEnum } from '../../../types/graphql-generated';

export const CAREER_ROLE_OPTIONS: { value: CareerRoleEnum; label: string }[] = [
  { value: CareerRoleEnum.Player, label: 'Jugador' },
  { value: CareerRoleEnum.Coach, label: 'Entrenador' },
  { value: CareerRoleEnum.FitnessCoach, label: 'Preparador físico' },
  { value: CareerRoleEnum.Executive, label: 'Directivo' },
  { value: CareerRoleEnum.Physiotherapist, label: 'Fisioterapeuta' },
  { value: CareerRoleEnum.KitManager, label: 'Utillero' },
  { value: CareerRoleEnum.Supporter, label: 'Seguidor' },
  { value: CareerRoleEnum.Psychologist, label: 'Psicólogo' },
  { value: CareerRoleEnum.Referee, label: 'Árbitro' },
  { value: CareerRoleEnum.Journalist, label: 'Periodista' },
  { value: CareerRoleEnum.TeamDelegate, label: 'Delegado' },
];

export const CAREER_ROLE_LABELS = Object.fromEntries(
  CAREER_ROLE_OPTIONS.map(({ value, label }) => [value, label]),
) as Record<CareerRoleEnum, string>;

// The line registered as the user's career status when they choose to show
// a career entry on their profile. It matches CareerEntry#career_status in
// the backend, e.g. "Jugador de Avilés Stadium".
export const formatCareerStatus = (roleLabel: string, organizationName: string) =>
  `${roleLabel} de ${organizationName}`;
